var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    typography = _ref.typography,
    colors = _ref.colors;
  return {
    userResponsePadding: spacing.xSmall,
    userResponseMargin: spacing.xxSmall,
    userResponseFontSize: typography.fontSizeSmall,
    userResponseFontFamily: typography.fontFamily,
    gradingNotesWrapperMargin: spacing.xSmall,
    gradingNotesWrapperPadding: spacing.small,
    gradingNotesWrapperColor: colors.contrasts.grey1111,
    gradingNotesWrapperBorderRadius: borders.radiusMedium
  };
};
export default generateComponentTheme;